import React from 'react';
import styled from 'styled-components';

export const LoginIcon = () => (
    <svg
        width="20.000000"
        height="20.000000"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <clipPath id="clip1437_12254">
                <rect
                    id="Icon / User 1"
                    width="20.000000"
                    height="20.000000"
                    fill="white"
                    fillOpacity="0"
                />
            </clipPath>
        </defs>
        <rect
            id="Icon / User 1"
            width="20.000000"
            height="20.000000"
            fill="#FFFFFF"
            fillOpacity="0"
        />
        <g clipPath="url(#clip1437_12254)">
            <path
                id="Union"
                d="M9.99 2.5C8.89 2.5 7.83 2.93 7.05 3.72C6.27 4.5 5.83 5.56 5.83 6.66C5.83 7.77 6.27 8.83 7.05 9.61C7.1 9.66 7.16 9.72 7.22 9.77C6.5 10.09 5.85 10.55 5.28 11.11C4.03 12.36 3.33 14.06 3.33 15.83L3.33 16.66C3.33 17.12 3.7 17.5 4.16 17.5C4.62 17.5 4.99 17.12 4.99 16.66L4.99 15.83C4.99 14.5 5.52 13.23 6.46 12.29C7.4 11.36 8.67 10.83 9.99 10.83C11.32 10.83 12.59 11.36 13.53 12.29C14.47 13.23 14.99 14.5 14.99 15.83L14.99 16.66C14.99 17.12 15.37 17.5 15.83 17.5C16.29 17.5 16.66 17.12 16.66 16.66L16.66 15.83C16.66 14.06 15.96 12.36 14.71 11.11C14.14 10.55 13.49 10.09 12.77 9.77C12.83 9.72 12.89 9.66 12.94 9.61C13.72 8.83 14.16 7.77 14.16 6.66C14.16 5.56 13.72 4.5 12.94 3.72C12.16 2.93 11.1 2.5 9.99 2.5ZM8.23 4.89C8.7 4.43 9.33 4.16 9.99 4.16C10.66 4.16 11.29 4.43 11.76 4.89C12.23 5.36 12.49 6 12.49 6.66C12.49 7.32 12.23 7.96 11.76 8.43C11.29 8.9 10.66 9.16 9.99 9.16C9.33 9.16 8.7 8.9 8.23 8.43C7.76 7.96 7.49 7.32 7.49 6.66C7.49 6 7.76 5.36 8.23 4.89Z"
                fill="#718EBF"
                fillOpacity="0.960000"
                fillRule="evenodd"
            />
        </g>
    </svg>
);

export const RegisterIcon = () => (
    <svg
        width="17.000000"
        height="17.000000"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <desc>Created with Pixso.</desc>
        <defs />
        <path
            id="Icon"
            d="M12 4.33C13.4 4.33 14.1 4.33 14.63 4.6C15.1 4.84 15.48 5.22 15.72 5.69C15.88 5.99 15.94 6.35 15.97 6.85C16 7.24 16 7.72 16 8.33L16 12C16 13.4 16 14.1 15.72 14.63C15.48 15.1 15.1 15.48 14.63 15.72C14.1 16 13.4 16 12 16L5 16C3.59 16 2.89 16 2.36 15.72C1.89 15.48 1.51 15.1 1.27 14.63C1 14.1 1 13.4 1 12L1 8.33C1 7.72 1 7.24 1.02 6.85C1.05 6.35 1.11 5.99 1.27 5.69C1.51 5.22 1.89 4.84 2.36 4.6C2.89 4.33 3.59 4.33 5 4.33L12 4.33ZM5.16 4.33L5.16 3.66C5.16 2.73 5.16 2.26 5.34 1.91C5.5 1.59 5.76 1.34 6.07 1.18C6.43 1 6.89 1 7.83 1L9.16 1C10.1 1 10.56 1 10.92 1.18C11.23 1.34 11.49 1.59 11.65 1.91C11.83 2.26 11.83 2.73 11.83 3.66L11.83 4.33M15.97 6.85C15.67 7.14 12.42 10.16 8.5 10.16C4.57 10.16 1.32 7.14 1.02 6.85"
            stroke="#718EBF"
            strokeOpacity="1.000000"
            strokeWidth="2.000000"
            strokeLinejoin="round"
            strokeLinecap="round"
        />
    </svg>
);

export const ComissionIcon = () => (
    <svg
        width="17.000000"
        height="15.333313"
        viewBox="0 0 17 15.3333"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <desc>Created with Pixso.</desc>
        <defs />
        <path
            id="Icon"
            d="M5.16 6C3.78 6 2.66 4.88 2.66 3.5C2.66 2.11 3.78 1 5.16 1C6.54 1 7.66 2.11 7.66 3.5C7.66 4.88 6.54 6 5.16 6ZM8.83 10.69C9.59 9.85 10.65 9.33 11.83 9.33C14.13 9.33 16 11.04 16 13.5L16 14.33L9.33 14.33L1 14.33L1 12.66C1 10.36 2.86 8.5 5.16 8.5C7.46 8.5 9.33 10.36 9.33 12.66L9.33 14.33M11.83 6.83C10.91 6.83 10.16 6.08 10.16 5.16C10.16 4.24 10.91 3.5 11.83 3.5C12.75 3.5 13.5 4.24 13.5 5.16C13.5 6.08 12.75 6.83 11.83 6.83Z"
            stroke="#718EBF"
            strokeOpacity="1.000000"
            strokeWidth="2.000000"
            strokeLinejoin="round"
            strokeLinecap="round"
        />
    </svg>
);
export const DocumentsIcon = () => (
    <svg
        width="15.000000"
        height="18.333313"
        viewBox="0 0 15 18.3333"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <desc>Created with Pixso.</desc>
        <defs />
        <path
            id="Union"
            d="M14.6 3.01C14.73 3.13 14.83 3.28 14.89 3.44C14.96 3.6 15 3.78 15 3.95L14.16 3.95L15 3.96L15 3.95L15 17C15 17.17 14.96 17.34 14.89 17.51C14.83 17.67 14.73 17.81 14.6 17.94C14.48 18.06 14.33 18.16 14.17 18.23C14.01 18.29 13.84 18.33 13.66 18.33L1.33 18.33C1.15 18.33 0.98 18.29 0.82 18.23C0.66 18.16 0.51 18.06 0.39 17.94C0.26 17.81 0.16 17.67 0.1 17.51C0.03 17.34 0 17.17 0 17L0 1.33C0 0.97 0.14 0.64 0.39 0.39C0.64 0.14 0.97 0 1.33 0L11.04 0C11.39 0 11.73 0.14 11.98 0.39L14.6 3.01ZM11.25 5C10.55 5 10 4.44 10 3.75L10 1.66L1.66 1.66L1.66 16.66L13.33 16.66L13.33 5L11.25 5ZM11.66 2.42L12.57 3.33L11.66 3.33L11.66 2.42ZM3.33 7.5C3.33 7.03 3.7 6.66 4.16 6.66L10.83 6.66C11.29 6.66 11.66 7.03 11.66 7.5C11.66 7.96 11.29 8.33 10.83 8.33L4.16 8.33C3.7 8.33 3.33 7.96 3.33 7.5ZM3.33 10.83C3.33 10.37 3.7 10 4.16 10L7.5 10C7.96 10 8.33 10.37 8.33 10.83C8.33 11.29 7.96 11.66 7.5 11.66L4.16 11.66C3.7 11.66 3.33 11.29 3.33 10.83ZM4.16 13.33C3.7 13.33 3.33 13.7 3.33 14.16C3.33 14.62 3.7 15 4.16 15L10.83 15C11.29 15 11.66 14.62 11.66 14.16C11.66 13.7 11.29 13.33 10.83 13.33L4.16 13.33Z"
            fill="#718EBF"
            fillOpacity="1.000000"
            fillRule="evenodd"
        />
    </svg>
);

export const SettingsIcon = () => (
    <svg
        width="18.333374"
        height="18.333313"
        viewBox="0 0 18.3334 18.3333"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <desc>Created with Pixso.</desc>
        <defs />
        <path
            id="Union"
            d="M7.51 0.62C7.6 0.25 7.93 0 8.31 0L9.94 0C10.32 0 10.65 0.25 10.75 0.62L11.16 2.19L12.56 2.77L13.62 1.86C13.95 1.58 14.44 1.6 14.75 1.91L16.42 3.57C16.72 3.88 16.74 4.37 16.46 4.7L15.56 5.77L16.12 7.12L17.7 7.52C18.07 7.61 18.33 7.95 18.33 8.33L18.33 9.98C18.33 10.36 18.07 10.69 17.7 10.78L16.12 11.2L15.56 12.55L16.46 13.62C16.74 13.95 16.72 14.44 16.42 14.75L14.75 16.42C14.44 16.73 13.93 16.74 13.6 16.45L13.56 16.41C13.53 16.38 13.49 16.34 13.43 16.3C13.33 16.2 13.18 16.07 13.03 15.94C12.87 15.8 12.71 15.66 12.57 15.55L11.2 16.12L10.8 17.7C10.71 18.07 10.38 18.33 10 18.33L8.33 18.33C7.95 18.33 7.61 18.07 7.52 17.7L7.12 16.12L5.8 15.57L4.69 16.47C4.36 16.74 3.87 16.72 3.57 16.42L1.91 14.75C1.59 14.44 1.58 13.94 1.87 13.61L2.79 12.58L2.22 11.24L0.61 10.8C0.25 10.7 0 10.37 0 10L0 8.33C0 7.94 0.26 7.6 0.64 7.52L2.2 7.15L2.75 5.8L1.85 4.69C1.58 4.36 1.6 3.87 1.91 3.57L3.57 1.91C3.88 1.59 4.39 1.58 4.72 1.87L5.74 2.79L7.08 2.22L7.51 0.62ZM14.13 14.69L14.7 14.12L13.96 13.24C13.75 13 13.7 12.67 13.82 12.38L14.74 10.17C14.84 9.93 15.04 9.75 15.3 9.69L16.66 9.33L16.66 8.98L15.31 8.63C15.05 8.57 14.84 8.39 14.74 8.14L13.83 5.93C13.71 5.65 13.76 5.32 13.96 5.08L14.7 4.21L14.12 3.63L13.26 4.36C13.02 4.57 12.69 4.62 12.4 4.5L10.14 3.57C9.9 3.47 9.72 3.27 9.65 3.02L9.3 1.66L8.95 1.66L8.59 3.04C8.53 3.29 8.35 3.5 8.11 3.6L5.91 4.53C5.61 4.65 5.27 4.59 5.03 4.38L4.2 3.64L3.62 4.22L4.35 5.13C4.54 5.36 4.59 5.68 4.48 5.97L3.58 8.18C3.48 8.43 3.26 8.62 3 8.68L1.66 8.99L1.66 9.36L3.05 9.74C3.3 9.8 3.5 9.98 3.6 10.22L4.53 12.42C4.65 12.72 4.59 13.06 4.38 13.3L3.64 14.13L4.22 14.71L5.13 13.97C5.36 13.77 5.69 13.72 5.97 13.84L8.14 14.73C8.39 14.83 8.57 15.05 8.63 15.3L8.98 16.66L9.35 16.66L9.69 15.3C9.76 15.05 9.94 14.84 10.18 14.74L12.39 13.82C12.65 13.71 12.96 13.75 13.19 13.91C13.42 14.07 13.81 14.41 14.12 14.68L14.13 14.69ZM6.8 6.8C7.43 6.18 8.28 5.83 9.16 5.83C10.05 5.83 10.89 6.18 11.52 6.8C12.14 7.43 12.5 8.28 12.5 9.16C12.5 10.05 12.14 10.89 11.52 11.52C10.89 12.14 10.05 12.5 9.16 12.5C8.28 12.5 7.43 12.14 6.8 11.52C6.18 10.89 5.83 10.05 5.83 9.16C5.83 8.28 6.18 7.43 6.8 6.8ZM9.16 7.5C8.72 7.5 8.3 7.67 7.98 7.98C7.67 8.3 7.5 8.72 7.5 9.16C7.5 9.6 7.67 10.03 7.98 10.34C8.3 10.65 8.72 10.83 9.16 10.83C9.6 10.83 10.03 10.65 10.34 10.34C10.65 10.03 10.83 9.6 10.83 9.16C10.83 8.72 10.65 8.3 10.34 7.98C10.03 7.67 9.6 7.5 9.16 7.5Z"
            fill="#718EBF"
            fillOpacity="1.000000"
            fillRule="evenodd"
        />
    </svg>
);

export const LoadFileIcon = () => (
    <svg
        width="31.000000"
        height="20.000000"
        viewBox="0 0 31 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <desc>Created with Pixso.</desc>
        <defs />
        <path
            id="Icon"
            d="M15.5 6.78L15.5 14.5M12.27 9.35L15.5 6.78L18.72 9.35M1 12.12C1 10.05 2.25 8.08 4.34 6.82C6.57 5.47 8.88 3.91 11.08 2.53C12.61 1.58 14.53 1 16.61 1C19.2 1 21.55 1.86 23.2 3.25C25.64 5.3 28.17 8.21 29.52 11.1C29.83 11.76 30 12.48 30 13.21C30 16.4 26.75 19 22.75 19L9.7 19C4.89 19 1 15.91 1 12.12Z"
            stroke="#C8DEDE"
            strokeOpacity="1.000000"
            strokeWidth="2.000000"
            strokeLinejoin="round"
            strokeLinecap="round"
        />
    </svg>
);

export const CoursesMenuIcon = () => (
    <svg
        width="18.708984"
        height="15.345703"
        viewBox="0 0 18.709 15.3457"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <desc>Created with Pixso.</desc>
        <defs />
        <path
            id="Icon"
            d="M17.7 5.17L9.37 9.33L1.04 5.17L9.37 1L17.7 5.17L17.7 10.17M15.2 6.42L15.2 11.42L9.37 14.33L3.54 11.42L3.54 6.42"
            stroke="#718EBF"
            strokeOpacity="1.000000"
            strokeWidth="2.000000"
            strokeLinejoin="round"
            strokeLinecap="round"
        />
    </svg>
);

const NoAvatarSvg = styled.svg`
    width: 100%;
    height: auto;
`;

export const NoAvatar = () => (
    <NoAvatarSvg
        xmlns="http://www.w3.org/2000/svg"
        width="500"
        height="500"
        viewBox="0 0 500 500"
    >
        <circle cx="250" cy="180" r="80" fill="#b3b3b3" />
        <ellipse cx="250" cy="320" rx="120" ry="80" fill="#b3b3b3" />
    </NoAvatarSvg>
);
